/**
 * Select Component - Template
 * ===========================
 */

export const SELECT_TEMPLATE: string = `
<div class="ec-select" ng-class="$ctrl.getWrapperClasses()">
  <label ng-if="$ctrl.label || $ctrl.hasLabelSlot" ng-attr-id="{{ $ctrl.labelId }}" ng-class="$ctrl.getLabelClasses()">
    <span ng-if="$ctrl.hasLabelSlot" ng-transclude="labelSlot"></span>
    <span ng-if="!$ctrl.hasLabelSlot">{{ $ctrl.label }}</span>
  </label>

  <div ng-class="$ctrl.getRelativeClasses()">
    <button
      type="button"
      ng-class="$ctrl.getTriggerClasses()"
      ng-click="$ctrl.toggle($event)"
      ng-keydown="$ctrl.handleKeydown($event)"
      ng-disabled="$ctrl.disabled"
      aria-haspopup="listbox"
      ng-attr-aria-expanded="{{ $ctrl.open ? 'true' : 'false' }}"
      ng-attr-aria-labelledby="{{ ($ctrl.label || $ctrl.hasLabelSlot) ? $ctrl.labelId : undefined }}"
      ng-attr-aria-label="{{ (!$ctrl.label && !$ctrl.hasLabelSlot) ? $ctrl.ariaLabel : undefined }}"
    >
      <span ng-if="$ctrl.selectedOption" ng-class="$ctrl.getTriggerTextClasses()">
        <span ng-if="$ctrl.selectedOption.icon">{{ $ctrl.selectedOption.icon }}</span>
        <span>{{ $ctrl.selectedOption.label }}</span>
      </span>
      <span ng-if="!$ctrl.selectedOption" ng-class="$ctrl.getPlaceholderClasses()">{{ $ctrl.placeholder }}</span>
      <span ng-class="$ctrl.getChevronClasses()" ng-bind-html="$ctrl.trustedChevron" aria-hidden="true"></span>
    </button>

    <ul ng-if="$ctrl.open" ng-class="$ctrl.getPanelClasses()" role="listbox">
      <li
        ng-repeat="opt in $ctrl.effectiveOptions track by opt.value"
        ng-class="$ctrl.getOptionClasses(opt)"
        ng-click="$ctrl.selectOption(opt, $event)"
        role="option"
        ng-attr-aria-disabled="{{ opt.disabled ? 'true' : undefined }}"
        ng-attr-aria-selected="{{ opt.value === $ctrl.selectedValue ? 'true' : 'false' }}"
      >
        <span ng-if="opt.icon">{{ opt.icon }}</span>
        <span>{{ opt.label }}</span>
      </li>
    </ul>
  </div>

  <span ng-if="$ctrl.helpMessage || $ctrl.hasHelpSlot" ng-class="$ctrl.getHelpClasses()">
    <span ng-if="$ctrl.hasHelpSlot" ng-transclude="helpSlot"></span>
    <span ng-if="!$ctrl.hasHelpSlot">{{ $ctrl.helpMessage }}</span>
  </span>

  <!-- Outlet del slot default: enlaza hijos de configuración (ec-select-option)
       que no matchean ningún slot nombrado. No se renderiza nada visible. -->
  <div ng-transclude class="ec-hidden" aria-hidden="true"></div>
</div>
`;

export default SELECT_TEMPLATE;
